import {
  GetControversiaCurp,
  PutLiberarCurp
} from "../../../reducers/personaReferencia";

export interface ControversiaCurpStore
  extends GetControversiaCurp,
    PutLiberarCurp {}

export const controversiaCurpStore: (
  state
) => ControversiaCurpStore = state => {
  const { personaReferencia } = state;
  return {
    controversiaCurp: personaReferencia.controversiaCurp,
    gettingControversiaCurp: personaReferencia.gettingControversiaCurp,
    gettingControversiaCurpError:
      personaReferencia.gettingControversiaCurpError,
    puttingLiberarCurp: personaReferencia.puttingLiberarCurp,
    puttingLiberarCurpError: personaReferencia.puttingLiberarCurpError
  };
};
